'use client'

import type { AnnualReportAnimation } from '@/.generated/sanityTypes/graphql'
import type { Locale } from '@/i18n'
import useMatchMedia from '@/lib/mediaQuery'
import { useLocale } from 'next-intl'
import React, { useRef, useState } from 'react'
import { PlayIcon } from './Icons'

const VideoAnimation = ({
  animationFile,
  animationFileMobile,
}: AnnualReportAnimation) => {
  const locale = useLocale() as Locale
  const videoSourceDesktop = animationFile?.[locale]?.asset?.url
  const videoSourceMobile = animationFileMobile?.[locale]?.asset?.url
  const isDesktop = useMatchMedia('(min-width: 768px)')?.matches
  const src =
    isDesktop === undefined
      ? undefined
      : isDesktop
        ? videoSourceDesktop
        : videoSourceMobile

  const videoRef = useRef<HTMLVideoElement>(null)

  const [isPlaying, setIsPlaying] = useState(false)

  const handleOnPlay = () => {
    setIsPlaying(true)
  }

  const handleStartPlay = () => {
    videoRef.current?.play()
  }

  return (
    <>
      <div className="pb-9/16 md:pb-16/9 relative h-0 w-full bg-gray-500">
        {src && (
          <video
            ref={videoRef}
            className="w-full"
            autoPlay
            loop
            muted
            onPlay={handleOnPlay}
            onClick={handleStartPlay}
          >
            <source src={src} type="video/mp4" />
          </video>
        )}
        {isPlaying ? null : (
          <button
            className="z-1 absolute bottom-1/2 left-1/2"
            onClick={handleStartPlay}
          >
            <PlayIcon className="text-red h-16 w-16" />
          </button>
        )}
      </div>
    </>
  )
}

export default VideoAnimation
